import type { DataTableSortData } from '../../ui/DataTable/types';
import type { DataTableProviderFilterStateValue } from './types';

export type DatatableSessionSnapshot = {
  filters: Array<[string, DataTableProviderFilterStateValue]>;
  searchTerm: string;
  sort: DataTableSortData | null;
};

/**
 * Resolve column sort for DataTableProvider mount.
 *
 * Legacy behaviour: any URL query string (or defaultFilter) skips session
 * restore entirely, so sort falls back to defaultSort.
 *
 * BUGS-2863 opt-in (`restoreSessionSortWhenUrlHasParams`): keep session sort
 * for that table only (pipeline deals List), without changing other tables.
 */
export function resolveInitialSortFromSession(args: {
  session: DatatableSessionSnapshot | null;
  search: string;
  defaultFilter?: Map<string, DataTableProviderFilterStateValue> | null;
  defaultSort?: DataTableSortData | null;
  restoreSessionSortWhenUrlHasParams?: boolean;
}): DataTableSortData | null {
  const { session, defaultSort = null, restoreSessionSortWhenUrlHasParams } =
    args;

  const searchParams = new URLSearchParams(
    args.search.startsWith('?') ? args.search.slice(1) : args.search
  );
  const hasAnyQuery = searchParams.toString().length > 0;
  const hasDefaultFilter = Boolean(
    args.defaultFilter && args.defaultFilter.size > 0
  );
  const skipSessionFilters = hasAnyQuery || hasDefaultFilter;

  if (!skipSessionFilters) {
    return session?.sort ?? defaultSort ?? null;
  }

  if (restoreSessionSortWhenUrlHasParams && session?.sort) {
    return session.sort;
  }

  return defaultSort ?? null;
}
